module.exports = {"540323100":"类乌齐镇","540323101":"桑多镇","540323200":"甲桑卡乡","540323201":"长毛岭乡","540323202":"岗色乡","540323203":"吉多乡","540323204":"宾达乡","540323205":"卡玛多乡","540323206":"尚卡乡","540323207":"伊日乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540323.json
// module id = 2844
// module chunks = 0